import { render, staticRenderFns } from "./PolicyBox.vue?vue&type=template&id=772c06e8&scoped=true"
import script from "./PolicyBox.vue?vue&type=script&lang=js"
export * from "./PolicyBox.vue?vue&type=script&lang=js"
import style0 from "./PolicyBox.vue?vue&type=style&index=0&id=772c06e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772c06e8",
  null
  
)

export default component.exports